var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSirenTurnedOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_1258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.22047 14.8894L7.10956 18.7785L9.70229 16.1858L16.1841 16.1858L5.8132 5.81488L5.8132 12.2967L3.22047 14.8894ZM13.9155 8.08352C12.7682 6.93624 11.1218 6.61214 9.68284 7.0918L14.9007 12.3097C15.3868 10.8772 15.0627 9.2308 13.9155 8.08352ZM6.61046 4.01942L7.94572 5.35467C10.3764 4.03887 13.4812 4.40833 15.5359 6.46306C17.5907 8.5178 17.9601 11.6226 16.6443 14.0533L17.9796 15.3885C19.9889 12.1995 19.6065 7.94092 16.8323 5.1667C14.0581 2.39249 9.79951 2.01006 6.61046 4.01942Z",
    fill: "#14AC63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_1258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirenTurnedOn);
export default __webpack_public_path__ + "static/media/SirenTurnedOn.41aa3468c0a52d8a9498513a8f18b5ac.svg";
export { ForwardRef as ReactComponent };